import { defineHiddenProp, noop } from "./common";
import { Dep, Watcher } from "./Watcher";
var computedWatcherOptions = {
    lazy: true,
    computed: true
};
var defaultComputedOption = { enumerable: false };
export var watcherKey = '_watchers';
export function computed(targetOrOption, propertyKey) {
    if (propertyKey) {
        return createComputed(defaultComputedOption, targetOrOption, propertyKey);
    }
    else {
        return function (target, key) {
            return createComputed(targetOrOption, target, key);
        };
    }
}
export function createComputed(option, target, propertyKey) {
    var desc = Object.getOwnPropertyDescriptor(target, propertyKey);
    if (!(desc && desc.get)) {
        throw new Error('[@Getter] must be used for getter property');
    }
    var get = desc.get;
    return {
        get: function () {
            if (!this[watcherKey]) {
                defineHiddenProp(this, watcherKey, []);
            }
            var watcher = new Watcher(this, get, noop, computedWatcherOptions);
            var getter = createComputedGetter(watcher);
            Object.defineProperty(this, propertyKey, {
                get: getter,
                enumerable: option.enumerable,
                configurable: true
            });
            return getter();
        },
        enumerable: option.enumerable,
        configurable: true
    };
}
function createComputedGetter(watcher) {
    return function computedGetter() {
        if (watcher.dirty) {
            watcher.evaluate();
        }
        if (Dep.target) {
            watcher.depend();
        }
        return watcher.value;
    };
}
export function dispose(state) {
    var watchers = state[watcherKey];
    if (!Array.isArray(watchers)) {
        return;
    }
    var i = watchers.length;
    while (i--) {
        watchers[i].teardown();
    }
}
